import React, {useState, useEffect} from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth,
    API
} from 'aws-amplify'

import * as mutations from '../graphql/mutations'

import { 
    Alert,
    Info,
    WhiteDiv, 
    HeaderDiv
} from '../Styles/BaseStyles'

import { 
    ComponentsDiv,
    ViewerDiv
} from '../Styles/Pages/AppViewerStyles'

import NavBar from '../Components/Action/NavBar'

import ResumeViewer from '../Components/Application/Viewers/ResumeViewer'
import CollegeViewer from '../Components/Application/Viewers/CollegeViewer'

import AlertBox from '../Components/Action/AlertBox'

import { 
    useForm, 
    FormProvider 
} from 'react-hook-form'

import { 
    useSelector, 
    useDispatch 
} from 'react-redux'

import { 
    hideAlert,
    resetDropDownAlert,
    reset as appViewerSliceReset 
} from '../Redux/Slices/AppViewerSlice'

import {
    hubInfo,
    setHubPage
} from '../Redux/Slices/HubSlice'

import { 
    showAlert as showSettingsAlertBox 
} from '../Redux/Slices/SettingsSlice'

import DeleteSection from '../Components/Application/UniversalSections/DeleteSection'

import { 
    generateDisplayName 
} from '../Utilities/HubTools'

import { 
    getApplicationDefaultValues 
} from '../Utilities/ApplicationTools'

function AppViewer(props){
    let history = useHistory()

    var data = history.location.state?.data

    const [load, setLoad] = useState(false)

    var values = {}

    const dispatch = useDispatch()

    const showAlert = useSelector(state => state.appViewer.showAlert)
    const alertType = useSelector(state => state.appViewer.alertType)
    const currentApplicationID = useSelector(state => state.appViewer.currentApplicationID)

    const storage = useSelector(state => state.user.storage)
    const locked = useSelector(state => state.appViewer.locked)
    const hubPage = useSelector(state => state.hub.hubPage)
    const mode = useSelector(state => state.appViewer.mode)

    const error = useSelector(state => state.appViewer.error)
    const errorPhrase = useSelector(state => state.appViewer.errorPhrase)
    const info = useSelector(state => state.appViewer.info)
    const infoPhrase = useSelector(state => state.appViewer.infoPhrase)

    const user = useSelector(state => state.user.user)

    const paymentRequired = useSelector(state => state.hub.paymentRequired)

    useEffect(() => {
        switch(storage){
            case 'localstorage':
                Auth.configure({storage: localStorage})
                break
            case 'sessionstorage':
                Auth.configure({storage: sessionStorage})
                break
            default:
                break
        }
        Auth.currentAuthenticatedUser().then(() => {
            if(!paymentRequired || user.user_group !== 'none'){
                setLoad(true)
            }
            else{
                dispatch(showSettingsAlertBox({alertType: 'subscription'}))
                history.push('/settings')
            }
            /*if(user.email_verified && user.phone_number_verified){
                setLoad(true)
            }
            else{
                dispatch(showSettingsAlertBox({alertType: 'verification'}))
                history.push('/settings')
            }*/
        })
        .catch(() => {
            history.push('/login')
        })
    }, [])

    useEffect(() => {
        if(error || info){
            const timeId = setTimeout(() => {
                dispatch(resetDropDownAlert())
            }, 3000)
            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dispatch,error,info])

    switch(props.viewType){
        case "resume":
            dispatch(setHubPage({hubPage: 'resume'}))
            const defaults = getApplicationDefaultValues(props.viewType)
            values = {
                application_details: {name: data ? data.application_details.name : "", tags: data ? data.application_details.tags : ""},
                experiences: data && data.experiences ? data.experiences : defaults.experiences,
                education: data && data.education ? data.education : defaults.education,
                projects: data && data.projects ? data.projects : defaults.projects,
                additional_links: data && data.additional_links ? data.additional_links : defaults.additional_links,
                references: data && data.references ? data.references : defaults.references,
                skills: {skills: data ? data.skills.skills : ""},
                contact_information: {name: data ? data.contact_information.name : user.firstname+" "+user.lastname, email: data ? data.contact_information.email : user.email, phone_number: data ? data.contact_information.phone_number : user.phone_number, location: data ? data.contact_information.location : ""}
            }
            break
        case "college":
            dispatch(setHubPage({hubPage: 'college'}))
            values = {
                application_details: {name: data ? data.application_details.name : "", tags: data ? data.application_details.tags : ""},
            }
            break
        default:
            values = {}
            break
    }

    const methods = useForm({
        defaultValues: values
    })

    var view

    switch(props.viewType){
        case "resume":
            view = <ResumeViewer />
            break
        case "College":
            view = <CollegeViewer />
            break
        default:
            break
    }

    var viewer = (
        <>
        </>
    )

    const exitAlertInfo = {
        'alert_title': 'Continue to ' + generateDisplayName(hubPage) + ' Hub?', 
        'alert_phrase': generateDisplayName(hubPage) + ' Application hasn\'t been saved. Going back to your ' + generateDisplayName(hubPage) + ' Hub will discard all unsaved changes.', 
        'alert_type': 'action', 
        'primary_button_text': 'Continue', 
        'primary_button_function': () => {
            dispatch(hideAlert());
            dispatch(appViewerSliceReset());
            history.push('/hub')
        }, 
        'secondary_button_text': 'Cancel', 
        'secondary_button_function': () => dispatch(hideAlert()),
        'style': {
            'alert_title': {
                'color': '#4267B2'
            }, 
            'alert_phrase': {}, 
            'primary_button': {}, 
            'secondary_button': {}
        }
    }

    async function deleteApplication(){
        const app_name = data.application_details.name
        await API.graphql({ query: mutations.deleteResume, variables: {input: {id: currentApplicationID}}})
        dispatch(hubInfo({infoPhrase: 'Successfully deleted application ' + app_name}))
        dispatch(hideAlert())
        dispatch(appViewerSliceReset())
        history.push('/hub')
    }

    const deleteAlertInfo = {
        'alert_title': 'Delete Application?', 
        'alert_phrase': 'Are you sure you want to delete this application? Once deleted, the application can\'t be recovered', 
        'alert_type': 'action', 
        'primary_button_text': 'Delete', 
        'primary_button_function': () => {deleteApplication()}, 
        'secondary_button_text': 'Cancel', 
        'secondary_button_function': () => dispatch(hideAlert()),
        'style': {
            'alert_title': {
                'color': 'red'
            }, 
            'alert_phrase': {}, 
            'primary_button': {
                'color': 'red'
            }, 
            'secondary_button': {}
        }
    }

    if(load){
        viewer = (
            <div id="app-viewer">
                {(showAlert && alertType==='exit') && <AlertBox alertInfo = {exitAlertInfo} />}
                {(showAlert && alertType==='delete') && <AlertBox alertInfo = {deleteAlertInfo} />}
                <FormProvider {...methods}>
                    <HeaderDiv>
                        <WhiteDiv>
                            <NavBar page="AppViewer"/>
                        </WhiteDiv>
                    </HeaderDiv>
                    {error && <Alert style={{top: "5.5rem", position: "absolute"}}>{errorPhrase}</Alert>}
                    {info && <Info style={{top: "5.5rem", position: "absolute"}}>{infoPhrase}</Info>}
                    <ComponentsDiv>
                        <ViewerDiv>
                            <form>
                                {view}
                            </form>    
                            {!locked && mode !== 'create' ? <DeleteSection name="delete-Section" /> : null}
                        </ViewerDiv>
                    </ComponentsDiv>
                </FormProvider>
            </div>
        )
    }

    return (
        <>
            {viewer}
        </>
    )

}

export default AppViewer;